window.loaded = false;
var windowWidth = window.innerWidth;

$(window).on('load', function(){
	window.loaded = true;
	document.documentElement.classList.add('page-loaded');
});

var homeSlider = undefined;
var sliderType = 'swiper';
var headerBorder = undefined;
var header = undefined;

var sliderLists = undefined;
var sliders = {};

$(document).ready(function() {
	/* MOBILE */
	//create js hook links
	windowWidth = window.innerWidth;
	var resizeFn = function() {
		if (windowWidth != window.innerWidth) {
			windowWidth = window.innerWidth;

			$(document).trigger('pwstudio.window_width_changed', windowWidth);
		}
	}

	window.addEventListener('resize', resizeFn);

	headerBorder = $('[data-purpose="header-scroll-border"]');
	header = $('.main-header');
	if (headerBorder.length === 0) {
		headerBorder = $('.main-header');
	}

	if (headerBorder && headerBorder.length > 0) {
		var headerScrollFn = function() {
			var height = headerBorder.outerHeight(true) + headerBorder.offset().top;
			var scrollTop = $(window).scrollTop()

			if (height <= scrollTop && !header.hasClass('opened-fix-menu')) {
				header.addClass('opened-fix-menu');
				$('body').addClass('opened-fix-menu');
			} else if (height > scrollTop && header.hasClass('opened-fix-menu')) {
				header.removeClass('opened-fix-menu');

				$('.main-header').find('.submenu').hide(0, function() {
					var submenu = $(this);
					setTimeout(function(){
						submenu.removeAttr('style');
					}, 250);
				});
			}
		};

		window.addEventListener('touchend', headerScrollFn);
		window.addEventListener('touchmove', headerScrollFn);
		window.addEventListener('scroll', headerScrollFn);
	}

	$('.mailtolink').click(function(e) {
		handleMailtoLink($(this));
	});

	$('[data-purpose="navigation-link"]').each(function(){
		setNavigationUrl($(this));
	});

	$('.attractions-line .inner-content').infiniteslide({
		pauseonhover: false,
		speed:30,
	});

	$('.remodal-open-button').click(function(){
		var target = $(this).data('popup-id');		
		if (target) {
			var item = $('[data-remodal-id="'+target+'"]');
			if (item.length == 1) {
				item.remodal().open();
			}
		}
	});

	$('[data-purpose="save-form-button"]').click(function(){
		var _self = this;
		var sendedForm = false;

		if (!sendedForm) {
			sendedForm = true;

			var notyf = new Notyf({
				delay:5000,
				alertIcon: 'notyf-error-icon',
				confirmIcon: 'notyf-confirm-icon'
			});

			var form = $(this.closest("form"));

			$.ajax({
				url:form.attr('action'),
				dataType:'json',
				type:'post',
				data: form.serialize(),
				beforeSend: function() {
					form.find('.has-error').removeClass('has-error');
				},
				success: function(response) {
					if (response.success) {
						if ((response.msg).trim() !== '') {
							notyf.confirm(response.msg);
						}
						setTimeout(function(){
							window.location.href = response.url;
						}, 2000);
					} else {
						if (typeof response.errors == 'object') {
							$.each(response.errors, function(key, value) {
								if (value.trim() !== '') {
									notyf.alert(value);
								}

								var input = form.find('[name="'+key+'"]');
								if (input.length > 0) {
									input.addClass('has-error');
								}
							});
						}

						setTimeout(function() {
							sendedForm = false;
						}, 500);
					}
				},
			});
		}
	});

	$('[data-purpose="remodal-close"]').click(function(){
		var value = $(this).data('value');
		if (value && value == 'confirm') {
			$('#terms-chk').attr('checked', true);
		}

		$(this).parents('.remodal').remodal().close();
	});

	$('[data-purpose="scroll-to-element"]').click(function(){
		var target = $(this).data('target');
		var item = $(target);
		var timeout = $(this).data('timeout');

		if (isNaN(timeout)) {
			timeout = 400;
		}

		if (item.length > 0) {
			var top = item.offset().top;
			if (header && header.length == 1) {
				top -= (header.outerHeight(true) + 170);
			}
			$('html, body').animate({scrollTop: top}, timeout);
		}
	});

	$('[data-purpose="remodal-open"]').click(function(){
		var target = $(this).data('target');
		if (target) {
			var companyId = $(this).data('company-id');

			if (companyId) {
				$('[data-purpose="local-service-id"]').val(companyId);
			}
			openRemodalContent(target);
		}
	});

	$('[data-purpose="privacy-confirm-button"]').click(function(){
		var type = $(this).data('type');
		$('#privacyChk').prop('checked', type == 'accept');
		$('[data-remodal-id="privacyRemodal"]').remodal().close();
	});

	if (typeof site_id !== 'undefined') {
		if (site_id == 1) {
			switch(sliderType) {
				case 'bxslider':
					initHomeBxSlider();
					break;
				case 'swiper':
					initHomeSwiperSlider();
					break;
			}
		}
	}

	$('select').change(function(){
		var value = parseInt($(this).val());

		if (!value && $(this).hasClass('has-value')) {
			$(this).removeClass('has-value');
		} else if (value && !$(this).hasClass('has-value')) {
			$(this).addClass('has-value');
		}
	}).change();

	$('.accordion-list').each(function(ind, el) {

		var options = {};
		var th = $(el);
		if (th.data('single-active-item') != undefined) options.singleActiveItem = true;
		if (th.data('active-index') != undefined) options.activeIndex = th.data('active-index');
		if (th.data('from-width') != undefined) options.fromWidth = parseInt(th.data('from-width'));

		new Accordion(th, options);
	});

      if (typeof mediaGroupItems === 'object' && Object.keys(mediaGroupItems).length > 0) {
        $('[data-purpose="gallery-item"]').click(function() {
            openGallery($(this));
        });
	}

	sliderLists = $('[data-purpose="slider-list"]');

	if (sliderLists && sliderLists.length > 0) {
		var seq = 1;
		$.each(sliderLists, function(){

			$(this).attr('data-seq', seq);
			seq++;

			initSlider($(this));
		});
	}

	if (typeof ItemSlider !== 'undefined') {
		var sliders = $('[data-purpose="item-slider"]');

		if (sliders.length > 0) {
			sliders.each(function(){
				new ItemSlider($(this));
			});
		}
	}

	var youtubePlay = $('[data-purpose="play-video"]');

	if (youtubePlay.length > 0) {
		youtubePlay.on('click', function(){
			$(this).find('.video-frame').show();
			this.style.background = '';
		});
	}

	$('[data-purpose="lang-chooser"]').change(function(){
		changeFrontendLang($(this));
	});

	$('[data-purpose="openable-title-row"]').click(function(){
		var parent = $(this).parent('.openable-row');
		if (parent && parent.length === 1) {
			parent.toggleClass('opened');
			parent.find('.text-content').slideToggle(300);
		}
	});

	$('[data-purpose="stage-tag"]').click(function(){
		scrollToElement($(this).data('id'));
	});

	$('[data-purpose="stage-select"]').change(function(){
		scrollToElement($(this).val());
	});

	$('[data-purpose="add-to-cart"]').on('click', function () {
		var ticketId = $(this).data('ticket-id');
		addToCart(ticketId);
	});

	$(document).on('click', '[data-purpose="program-item"]', function () {
		var programId = $(this).data('program-id')
		if (!programId) {
			return;
		}

		openProgramModal(programId);
	});

	$(document).on('click', '[data-purpose="video-preview"]', function() {
		const container = $(this).closest('.video-container');
		const iframe = container.find('iframe');
		
		iframe.attr('src', iframe.attr('data-src'));
		$(this).fadeOut(300);
	});
});

function changeFrontendLang(select) {
	var option = select.find(':selected');
	if (option && option.length == 1) {
		var url = option.data('url');
		if (url.trim() !== '') {
			document.location.href = url;
		}
	}	
}

function initSlider(list) {
	var items = list.find('li');
	if (items.length > 1) {
		var touchDevice = false;
		if (navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/)) {
			touchDevice = true;
		}

		// sliders['sliderItem'+list.data('seq')] = list.bxSlider({
		// 	auto:true,
		// 	pause:5000,
		// 	infiniteLoop: true,
		// 	touchEnabled: touchDevice,
		// 	preventDefaultSwipeX: true,
		// 	preventDefaultSwipeY: false,
		// 	controls: false,
		// 	mode:'fade',
		// });
		var delay = parseInt(list.data('delay'));
		if (isNaN(delay)) {
			delay = 10000;
		}

		var speed = parseInt(list.data('speed'));
		if (isNaN(speed)) {
			speed = 800;
		}

		var seq = list.data('seq');

		var parent = list.parent();
		var id = parent.attr('id');
		if (!id) {
			id = 'sliderItem'+seq;
			parent.attr('id', id);
		}

		sliders['sliderItem'+seq] = new Swiper('#'+id, {
			speed: speed,
			autoplay: {
				delay:delay
			},
			pagination: {
				el:'.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.next',
				prevEl: '.prev'
			}
		});
		// sliders['sliderItem'+seq].autoplay.start();
	}
}

function openRemodalContent(remodal_id) {
	var tmp = $('[data-remodal-id="'+remodal_id+'"]');
	if(tmp.length > 0){
	  tmp.remodal().open();
	}
}

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function sendAnalyticsEvent(action, category, tag) {
	if (typeof gtag !== 'undefined' && action && category) {
		var evtData = {
			event_category: category,
		};

		if (tag && tag.trim() != '') {
			evtData.event_label = tag;
		}

		gtag('event', action, evtData);
	} else if(typeof ga != 'undefined' && action && category){
		if(tag && tag.trim() != ''){
			ga('send', 'event', action, category, tag);
		}else{
			ga('send', 'event', action, category);
		}
	}
}

function svg(id) {
	return '<span class="svg"><svg class="icon ' + id + '"><use xlink:href="#' + id + '" /></svg></span>';
}

function handleMailtoLink(th) {
	if (th.attr('href') == 'javascript:void(0)') {
		var hidden = th.children('.emailhidden');
		th.attr('href', 'mailto:' + hidden.data('user') + '@' + hidden.data('domain'));
	}
}

function loadJs(url, implementationCode){
    var scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;
    scriptTag.onreadystatechange = implementationCode;

    document.body.appendChild(scriptTag);
};

function setNavigationUrl(item) {
	var address = item.data('address');

	if (address) {
		var protocol = 'google';
		var ua = navigator.userAgent.toLowerCase();
		var plat = navigator.platform;
		var device = ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i) ? ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)[0] : false;

		if(device == 'iphone' || device == 'ipad' || device == 'ipod'){
			function iOSversion() {
					
				if (/iP(hone|od|ad)/.test(navigator.platform)) {
				  var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				  return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
				}
			}

			var ver = iOSversion() || [0];
			if (ver[0] >= 6) {
				protocol = 'apple';
			}
		}
		
		var urlSuffix = '/?daddr='+address;
		var nav_url = '';
		switch(protocol) {
			case 'apple':
				nav_url = 'maps://';
				break;
			default:
				nav_url = 'https://maps.google.com/maps';
				break;
		}
		item.attr('target', '_blank');
		item.attr('href', nav_url+urlSuffix);
	}
}

function initHomeBxSlider() {
	var touchDevice = false;
	  if (navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/)) {
	  	touchDevice = true;
	  }

	  homeSlider = $('#homeSlider').bxSlider({
		  auto:true,
		  pause:5000,
		  infiniteLoop: true,
		  touchEnabled: touchDevice,
		  preventDefaultSwipeX: true,
		  preventDefaultSwipeY: false,
		  controls: false,
		  mode:'fade',
		  speed: 1000,
		pager:false,
	  });

	  if (typeof LazyLoad !== 'undefined') {
		  var list = document.getElementById('homeSlider');
		  var items = list.getElementsByTagName('li');
		  for (var i = 0; i < items.length; i++) {
			  LazyLoad.load(items[i]);
		  }
	  }
  }

function initHomeSwiperSlider()
{
	homeSlider = new Swiper('#homeSlider', {
		effect: 'fade',
		autoplay: {
			delay:20000
		},
		pagination: {
			el:'.swiper-pagination',
			clickable: true
		}
	});
}

function openGallery(item) {
	var groupId = item.data('group-id');
	var index = item.data('index');
	
	if (typeof mediaGroupItems === 'object' && typeof mediaGroupItems[groupId] !== 'undefined') {
		if (!index) {
			index = 0;
		}

		initGallery(item, mediaGroupItems[groupId], index);
	} 
}

function openArticleGallery(item) {
	var groupId = $(item).data('gallery-id');
	if (groupId && typeof articleGalleryItems === 'object' && typeof articleGalleryItems[groupId] !== 'undefined') {
		initGallery(item, articleGalleryItems[groupId]);
	}
}

function initGallery(target, items, index) 
{
	if (!index) {
		index = 0;
	}

	$(target).lightGallery({
		dynamic:true,
		dynamicEl:items,
		index:index,
		hash:false,
		download: false
	});
}

function initGalleries()
{
	if (typeof mediaGroupItems === 'object' && Object.keys(mediaGroupItems).length > 0) {
		$('[data-purpose="gallery-box-item"]:not(.initialized)').each(function(){
			$(this).addClass('initialized');
			$(this).click(function(){
				var id = $(this).data('group-id');
				if (id && typeof mediaGroupItems[id] !== 'undefined') {
					initGallery($(this), mediaGroupItems[id]);
				}
			});
		});
	}
}

function scrollToElement(item_id){
    if(item_id==='body')
        $('html,body').animate({scrollTop: $('body').position().top}, 1000);
    else{
        $('html,body').animate({scrollTop: $('#'+item_id).position().top}, 1000);
    }
}

var addingToCart = false;

function addToCart(ticketId) {
	if (addingToCart) {
		return;
	}

	addingToCart = true;
	$.ajax({
		url: ajax_controller + '/addToCart/' + ticketId,
		type: 'get',
		dataType: 'json',
		success: function (response) {
			if (response.url) {
				window.open(response.url);
			}
		},
		complete: function () {
			setTimeout(function () {
				addingToCart = false;
			}, 500);
		}
	});
}

function initItemsSliderSection(selector, type, customOptions)
{
    if (0 >= $(selector).length) {
        return;
    }

    if (typeof customOptions === 'undefined') {
        customOptions = {};
    }

    var swiperSlider = null;
    var sliderInitialized = false;
    var breakpoint = customOptions.breakpoint || 600;

    var defaults = {
        direction: 'horizontal',
        autoHeight: false,
        enabled: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        mousewheel: {
            invert: true,
            sensitivity: 1,
            releaseEdges: false,
            forceToAxis: true,
            eventTarget: '.swiper-container'
        }
    };

    var swiperOptions = $.extend(true, {}, defaults, getSliderOptions(type));

    function initSliderSection() {
        if (window.innerWidth <= breakpoint || sliderInitialized) {
            return;
        }

        swiperSlider = new Swiper(selector, swiperOptions)
        sliderInitialized = true;
    }

    function checkSliderVisibility() {
        if (window.innerWidth <= breakpoint && sliderInitialized) {
            swiperSlider.destroy();
            sliderInitialized = false;
        } else if (window.innerWidth > breakpoint && !sliderInitialized) {
            initSliderSection();
        }
    }

    checkSliderVisibility();
    $(document).on('pwstudio.window_width_changed', function () {
       checkSliderVisibility();
    });
}

function getSliderOptions(type)
{
    switch (type) {
        case 'lineup':
            return {
                slidesPerView: 4,
                spaceBetween: 20,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                        enabled: true,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        enabled: true,
                    }
                }
            };
        case 'articles':
            return {
                slidesPerView: 3,
                spaceBetween: 30,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        enabled: true,
                    },
                }
            };
        case 'tickets':
            return {
                slidesPerView: 3,
                spaceBetween: 24,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    930: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        enabled: true,
                    },
                }
            };
		case 'featuredPrograms':
		case 'feedbacks':
            return {
                slidesPerView: 3,
                spaceBetween: 24,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        enabled: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        enabled: true,
                    },
                }
            };	
        default:
            return {};
    }
}

function initEventsPage() {
	var daysSelector = $('.events-page .date-selector-item');
	var dayContents = $('.events-page .day-content');
	var dateSelector = $('.events-page .date-selector').first();

	var scrollToCurrentEvent = function () {
		var activeDayContent = dayContents.filter('.active');

		if (activeDayContent.length === 0) {
			return;
		}

		var currentEventRow = activeDayContent.find('.event-row-current').first();

		if (currentEventRow.length === 0) {
			return;
		}

		var targetTopInViewport = 10;
		if (dateSelector.length === 1) {
			targetTopInViewport = dateSelector[0].getBoundingClientRect().bottom + 10;
		}

		var currentEventTopInViewport = currentEventRow[0].getBoundingClientRect().top;
		var targetScrollTop = window.pageYOffset + currentEventTopInViewport - targetTopInViewport;

		$('html, body').stop(true).animate({
			scrollTop: Math.max(0, targetScrollTop)
		}, 450);
	};

	if (daysSelector.length === 0 || dayContents.length === 0) {
		return;
	}

	setTimeout(scrollToCurrentEvent, 100);

	daysSelector.on('click', function () {
		if ($(this).hasClass('selected')) {
			return;
		}

		var selectedDay = $(this).data('date');

		daysSelector.removeClass('selected');
		$(this).addClass('selected');

		dayContents.removeClass('active');
		dayContents.filter('[data-day="' + selectedDay + '"]').addClass('active');

		setTimeout(scrollToCurrentEvent, 50);
	});
}

function openProgramModal(programId) {
	var modal = $('[data-remodal-id="event-remodal"]');
	if (0 === modal.length) {
		return
	}

	$.ajax({
		url: ajax_controller + 'getEvent/' + programId,
		type: 'get',
		dataType: 'json',
		success: function (response) {
			if (response.success) {
				modal.find('.remodal-inner').html(response.html);
				openRemodalContent('event-remodal');
				
				if (typeof window.lazyLoadInstance !== 'undefined') {
					window.lazyLoadInstance.update();
				}
			}
		}
	});
}